import styled from 'styled-components'
interface IItemProps {
  bg?: string;
  borderColor?: string;
  color?: string;
  border: string;
  input: boolean
}

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  color: #fff;
  position: relative;
  padding: 40px 0 0;
`

export const Options = styled.div`
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px 40px;
`

export const Option = styled.button`
  width: 100%;
  text-align: left;
  height: fit-content;
`
export const ContainerOptions = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`

export const OptionBox = styled.div`
  display: flex;
  height: 100%;
  min-width: 70px;
`

export const Item = styled.button<IItemProps>`
  padding: 8px 20px 8px 10px;
  width: 100%;

  border-radius: 15px;
  border: 2px solid ${({ borderColor }) => borderColor};
  color: ${({ color }) => color};
  font-size: 18px;
  line-height: 21px;
  cursor: pointer;
  text-align: left;
  background-color: ${({ bg }) => bg} ;
  opacity: ${({ disabled }) => disabled ? 0.7 : 1};

  & + & {
    margin-top: 15px;
  }
  

  &:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 5px;
    background-color: ${({ borderColor }) => borderColor};
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
    ${({ input }) => input ? 'right: -3px' : 'left: -3px'};
  }

  @media screen and (max-width: 400px) {
    padding: 5px;
   }
`

export const OptContent = styled.div`
  overflow: hidden;
  @media screen and (max-width: 400px) {
    font-size: 12px;
    white-space: break-spaces;
  }
`

export const OptWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
`

export const OpenButton = styled.button<any>`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 40px;
  width: 15px;
  z-index: 3;

  >.right {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 8.7px;
    border-color: transparent transparent transparent ${({ color }) => color};
  }

  >.bottom {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8.7px 5px 0 5px;
    border-color: ${({ color }) => color} transparent transparent transparent;
  }
`

export const OptionsHeader = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  top: 0;
`

export const OptionHeader = styled.div`
  width: 50%;
  text-align: center;

  span {
    text-align: center;
    background: #fff;
    color: #000;
    width: 28px;
    display: flex;
    margin: auto;
    height: 28px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    box-shadow: 1px 1px 1px 1px #d8d8d8;
  }
`
export const ClearButton = styled.button`
  background: #f1f1f1;
  font-weight: bold;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  color: #444;
  font-family: Poppins;
  border: 2px solid #606060;
  margin: 10px 0;

  :hover {
    background: #e5e3e3;
    color: #000;
  }
`

export const Connections = styled.div`
 
`
export const MouseFollower = styled.div<any>`
  position: absolute;
`
